import getSymbolFromCurrency from 'currency-symbol-map';
import { format, parseISO } from 'date-fns';
import { enGB } from 'date-fns/locale';
import Dinero from 'dinero.js';
import ExperienceType from '../constants/ExperienceType';

export const ERRORS = {
  REQUIRED: 'Ce champ est requis',
  TAKEN: 'Cette valeur est déjà prise',
  INVALID: 'Cette valeur n’est pas valide',
  EMAIL: 'Cette adresse mail n’est pas valide',
  EMAIL_NOT_FOUND: 'Cette adresse mail n’est pas enregistrée',
};

export const KoobStateEnum = {
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
  VALIDATED: 'validated',
  REFUSED: 'refused',
  NOT_REQUESTED: 'not_requested',
  CANCELED: 'canceled',
};

export const RequestStateEnum = {
  IN_PROGRESS: 'inProgress',
  FINISHED: 'finished',
}

export const initialLocale = {
  value: 'en',
  label: 'EN',
  alpha2: 'gb',
};

export const formatDate = (date, frmt) => {
  try {
    if (!date || !frmt) {
      return '';
    }
    const parsedDate = typeof date === 'string' ? parseISO(date) : date;
    return format(parsedDate, frmt, { locale: enGB });
  } catch (err) {
    return '';
  }
};

export const formatDateWithTimezone = (date) => {
  const formater = new Intl.DateTimeFormat('en-GB', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZone: 'UTC',
    timeZoneName: 'short'
  });
  try {
    return formater.format(new Date(date));
  } catch (err) {
    return '';
  }
}

export const formatImageLinkForCss = link => {
  return '\'' + encodeURI(link) + '\'';
};

export const getRole = role => {
  switch (role) {
    case 'to_admin':
      return 'user:roles.toAdmin';
    default:
      return 'user:roles.toUser';
  }
};

export const getIdToString = (model, id) => {
  const capitalizedModelName = model.charAt(0).toUpperCase() + model.slice(1);
  return btoa(`gid://phh/${capitalizedModelName}/${id}`);
};

export const encodeId = (model, id) => {
  const capitalizedModelName = model.charAt(0).toUpperCase() + model.slice(1);
  return btoa(`gid://phh/${capitalizedModelName}/${id}`);
};


export const decodeId = (idKoob) => {
  if (!idKoob) return null;
  try {
    const result = parseInt(idKoob);
    if (!isNaN(result)) {
      return result;
    }
  } catch (e) {
    return null;
  }
  const decoded = atob(idKoob.replace('\n', ''));
  return parseInt(decoded.substring(decoded.lastIndexOf('/') + 1));
}

export const getActionsCellWidth = actionsCount =>
  24 * actionsCount + 8 * (actionsCount - 1) + 16 * 2;

export const formatCurrencyLabel = currency =>
  `${currency.toUpperCase()}  ${getSymbolFromCurrency(currency)}`;

export const formatCurrency = ({ amount, currency }) => {
  if (!amount && amount !== 0) {
    return '';
  }

  try {
    return Dinero({ amount: Math.round(amount * 100), currency })
      .setLocale('fr')
      .toFormat()
      .toUpperCase();
  } catch (err) {
    return amount;
  }
};

export const phoneRegex =
  /^[+]?[0-9]{10,15}$/;

export const listSupports = [
  {
    name: 'Website',
  },
  {
    name: 'DMC Recommandation',
  },
  {
    name: 'Social media',
  },
  {
    name: 'Event',
  },
  {
    name: 'Advertisement',
  },
  {
    name: 'Mail',
  },
  {
    name: 'Personal',
  },
  {
    name: 'Others',
  },
];

export const generateMarker = ({ type, label, mainColor = '#FFFFFF', fillColor = '#F5700A' }) => {
  let svgContent = '';

  if (type === 'day') {
    svgContent =
      `<?xml version="1.0" encoding="UTF-8"?>
          <svg width="45px" height="60px" viewBox="0 0 36 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <title>Icons / Maps / Place Hotel</title>
            <defs>
              <path d="M18,4 C10.26,4 4,10.26 4,18 C4,28.5 18,44 18,44 C18,44 32,28.5 32,18 C32,10.26 25.74,4 18,4 Z" id="path-1"></path>
              <filter x="-30.4%" y="-16.2%" width="160.7%" height="143.7%" filterUnits="objectBoundingBox" id="filter-2">
                <feMorphology radius="0.5" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"></feMorphology>
                <feOffset dx="0" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
                <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
                <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.24 0" type="matrix" in="shadowBlurOuter1"></feColorMatrix>
              </filter>
            </defs>
            <g id="Icons-/-Maps-/-Place-Hotel" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="Path">
                <use fill="black" fill-opacity="1" filter="url(#filter-2)" xlink:href="#path-1"></use>
                <use fill="${mainColor}" fill-rule="evenodd" xlink:href="#path-1"></use>
              </g>
              <g id="Filled-/-maps-/-place" transform="translate(0.8,0)">
                <text x="50%" y="50%" font-size="16" fill="${fillColor}" text-anchor="middle" dominant-baseline="middle" font-weight="bold">${label}</text>
              </g>
            </g>
          </svg>`;
  }

  if (type === 'flag') {
    svgContent = `
      <svg width="45px" height="60px" viewBox="0 0 36 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <title>Icons / Maps / Place</title>
        <defs>
            <path d="M18,4 C10.26,4 4,10.26 4,18 C4,28.5 18,44 18,44 C18,44 32,28.5 32,18 C32,10.26 25.74,4 18,4 Z" id="path-1"></path>
            <filter x="-30.4%" y="-16.2%" width="160.7%" height="143.7%" filterUnits="objectBoundingBox" id="filter-2">
                <feMorphology radius="0.5" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"></feMorphology>
                <feOffset dx="0" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
                <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
                <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.24 0" type="matrix" in="shadowBlurOuter1"></feColorMatrix>
            </filter>
        </defs>
        <g id="Icons-/-Maps-/-Place-Hotel-Active" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Path">
                <use fill="black" fill-opacity="1" filter="url(#filter-2)" xlink:href="#path-1"></use>
                <use fill="${mainColor}" fill-rule="evenodd" xlink:href="#path-1"></use>
            </g>
            <g id="Filled-/-maps-/-place" transform="translate(8.000000 ,9.000000)" filter="url(#filter-3)">
                <g>
                    <g transform="translate(2, 4)">
                        <path fill="${fillColor}" d="M4 2c0-1.1-0.9-2-2-2s-2 0.9-2 2c0 0.7 0.4 1.4 1 1.7v12.3h2v-12.3c0.6-0.3 1-1 1-1.7z"></path>
                        <path fill="${fillColor}" d="M4 4c0 0 1-3 3.6-3 2.7 0 2.3 1 4.4 1 2.4 0 4-1 4-1v8c0 0-0.7 2-4 2-2.2 0-2.3-1-5-1-2.3 0-3 2-3 2v-8z"></path>
                    </g>
                </g>
            </g>
        </g>
       </svg>
    `;
  }

  if (type === 'AIR') {
    svgContent = `
      <svg width="45px" height="60px" viewBox="0 0 36 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>Icons / Maps / Place experience Active</title>
        <defs>
          <path d="M18 4C10.26 4 4 10.26 4 18c0 10.5 14 26 14 26s14 -15.5 14 -26c0 -7.74 -6.26 -14 -14 -14Z" id="path-1"/>
          <filter x="-30.4%" y="-16.2%" width="160.7%" height="143.7%" filterUnits="objectBoundingBox" id="filter-2">
            <feMorphology radius="0.5" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"/>
            <feOffset dx="0" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.24 0" type="matrix" in="shadowBlurOuter1"/>
          </filter>
          <filter color-interpolation-filters="auto" id="filter-3">
            <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.F5700A 0"/>
          </filter>
        </defs>
        <g id="Icons-/-Maps-/-Place-experience-Active" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Path">
            <use fill="black" fill-opacity="1" filter="url(#filter-2)" xlink:href="#path-1"/>
            <use fill="${mainColor}" fill-rule="evenodd" xlink:href="#path-1"/>
          </g>
          <g id="Filled-/-maps-/-place" transform="translate(8 9)" filter="url(#filter-3)">
            <g>
            <path fill="${fillColor}" d="M19.538 7.681c0.264 0.333 0.462 0.743 0.462 1.208 0 0.934 -0.75 1.635 -1.451 2.056 -0.733 0.441 -1.642 0.722 -2.358 0.722H12.705l-3.014 5.271c-0.295 0.521 -0.847 0.84 -1.448 0.84h-1.951c-0.767 0 -1.271 -0.705 -1.069 -1.417L6.566 11.667H4.722l-1.333 1.778C3.179 13.726 2.85 13.889 2.5 13.889H1.043C0.467 13.889 0 13.424 0 12.816c0 -0.066 0.014 -0.163 0.04 -0.257L1.089 8.889 0.04 5.219C0.014 5.125 0 5.028 0 4.931c0 -0.576 0.467 -1.042 1.043 -1.042H2.5c0.35 0 0.679 0.163 0.889 0.444L4.722 6.111h1.844L5.222 1.416C5.021 0.707 5.524 0 6.292 0h1.951c0.601 0 1.153 0.32 1.448 0.84L12.705 6.111h3.486c0.688 0 1.632 0.292 2.361 0.736 0.368 0.226 0.719 0.503 0.986 0.833zm-1.563 0.118c-0.601 -0.365 -1.316 -0.576 -1.785 -0.576H12.382c-0.201 0 -0.385 -0.108 -0.483 -0.281L8.726 1.391c-0.097 -0.173 -0.281 -0.28 -0.483 -0.28h-1.951l1.545 5.403c0.045 0.167 0.014 0.347 -0.09 0.486 -0.108 0.139 -0.271 0.222 -0.444 0.222H4.444c-0.205 0 -0.34 -0.083 -0.444 -0.222L2.5 5H1.133l1.067 3.736c0.029 0.101 0.029 0.205 0 0.306L1.133 12.778H2.5l1.5 -2c0.104 -0.139 0.24 -0.222 0.444 -0.222h2.858c0.174 0 0.337 0.083 0.444 0.222 0.104 0.139 0.135 0.319 0.09 0.486L6.292 16.667h1.951c0.201 0 0.385 -0.108 0.483 -0.281l3.174 -5.549c0.097 -0.174 0.281 -0.281 0.483 -0.281h3.809c0.472 0 1.188 -0.205 1.785 -0.563 0.628 -0.378 0.913 -0.788 0.913 -1.104 0 -0.142 -0.059 -0.344 -0.219 -0.514 -0.16 -0.198 -0.399 -0.399 -0.694 -0.576zM9.208 1.115l-0.483 0.276z"/>
            </g>
          </g>
        </g>
      </svg>
    `;
  }

  if (type === 'LAND') {
    svgContent = `
      <svg width="45px" height="60px" viewBox="0 0 36 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>Icons / Maps / Place experience Active</title>
        <defs>
          <path d="M18 4C10.26 4 4 10.26 4 18c0 10.5 14 26 14 26s14 -15.5 14 -26c0 -7.74 -6.26 -14 -14 -14Z" id="path-1"/>
          <filter x="-30.4%" y="-16.2%" width="160.7%" height="143.7%" filterUnits="objectBoundingBox" id="filter-2">
            <feMorphology radius="0.5" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"/>
            <feOffset dx="0" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.24 0" type="matrix" in="shadowBlurOuter1"/>
          </filter>
          <filter color-interpolation-filters="auto" id="filter-3">
            <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.F5700A 0"/>
          </filter>
        </defs>
        <g id="Icons-/-Maps-/-Place-experience-Active" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Path">
            <use fill="black" fill-opacity="1" filter="url(#filter-2)" xlink:href="#path-1"/>
            <use fill="${mainColor}" fill-rule="evenodd" xlink:href="#path-1"/>
          </g>
          <g id="Filled-/-maps-/-place" transform="translate(8 9)" filter="url(#filter-3)">
            <g>
            <path fill="${fillColor}" d="M4.156 3.461 2.98 7.578c0.25 -0.051 0.504 -0.078 0.77 -0.078h12.5c0.262 0 0.52 0.027 0.77 0.078L15.844 3.461c-0.27 -0.938 -1.125 -1.586 -2.102 -1.586H6.262c-0.977 0 -1.836 0.648 -2.102 1.586zM2.266 7.805 3.555 3.289C3.902 2.082 5.004 1.25 6.262 1.25h7.477c1.254 0 2.359 0.832 2.703 2.039l1.289 4.516c1.332 0.574 2.266 1.902 2.266 3.445v6.25c0 0.691 -0.559 1.25 -1.25 1.25H17.5c-0.691 0 -1.25 -0.559 -1.25 -1.25v-1.875H3.75v1.875c0 0.691 -0.559 1.25 -1.25 1.25H1.25c-0.691 0 -1.25 -0.559 -1.25 -1.25V11.25c0 -1.543 0.934 -2.871 2.266 -3.445zM16.25 15h3.125v-3.75c0 -1.727 -1.398 -3.125 -3.125 -3.125H3.75c-1.727 0 -3.125 1.398 -3.125 3.125v3.75h15.625zm0.625 0.625v1.875c0 0.344 0.281 0.625 0.625 0.625h1.25c0.344 0 0.625 -0.281 0.625 -0.625v-1.875h-2.5zm-16.25 0v1.875c0 0.344 0.281 0.625 0.625 0.625h1.25c0.344 0 0.625 -0.281 0.625 -0.625v-1.875H0.625zm3.75 -4.375a0.625 0.625 0 1 0 -1.25 0 0.625 0.625 0 1 0 1.25 0zm-1.875 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 1 1 -2.5 0zm13.75 0.625a0.625 0.625 0 1 0 0 -1.25 0.625 0.625 0 1 0 0 1.25zm0 -1.875a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 1 1 0 -2.5z"/>
            </g>
          </g>
        </g>
      </svg>
    `;
  }

  if (type === 'RAIL') {
    svgContent = `
      <svg width="45px" height="60px" viewBox="0 0 36 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>Icons / Maps / Place experience Active</title>
        <defs>
          <path d="M18 4C10.26 4 4 10.26 4 18c0 10.5 14 26 14 26s14 -15.5 14 -26c0 -7.74 -6.26 -14 -14 -14Z" id="path-1"/>
          <filter x="-30.4%" y="-16.2%" width="160.7%" height="143.7%" filterUnits="objectBoundingBox" id="filter-2">
            <feMorphology radius="0.5" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"/>
            <feOffset dx="0" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.24 0" type="matrix" in="shadowBlurOuter1"/>
          </filter>
          <filter color-interpolation-filters="auto" id="filter-3">
            <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.F5700A 0"/>
          </filter>
        </defs>
        <g id="Icons-/-Maps-/-Place-experience-Active" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Path">
            <use fill="black" fill-opacity="1" filter="url(#filter-2)" xlink:href="#path-1"/>
            <use fill="${mainColor}" fill-rule="evenodd" xlink:href="#path-1"/>
          </g>
          <g id="Filled-/-maps-/-place" transform="translate(8 9)" filter="url(#filter-3)">
            <g>
            <path fill="${fillColor}" d="M15.714 0.714c1.973 0 3.571 1.598 3.571 3.571v11.429c0 1.973 -1.598 3.571 -3.571 3.571H4.286c-1.973 0 -3.571 -1.598 -3.571 -3.571V4.286c0 -1.973 1.598 -3.571 3.571 -3.571h11.429zM4.286 0C1.92 0 0 1.92 0 4.286v11.429c0 2.205 1.665 4.022 3.808 4.259l-2.277 2.272c-0.138 0.138 -0.138 0.366 0 0.504s0.366 0.138 0.504 0l2.754 -2.75h10.42l2.754 2.754c0.138 0.138 0.366 0.138 0.504 0s0.138 -0.366 0 -0.504l-2.272 -2.272c2.143 -0.237 3.808 -2.054 3.808 -4.259V4.286c0 -2.366 -1.92 -4.286 -4.286 -4.286H4.286zm7.857 14.286a2.143 2.143 0 1 0 -4.286 0 2.143 2.143 0 1 0 4.286 0zm-2.143 -1.429a1.429 1.429 0 1 1 0 2.857 1.429 1.429 0 1 1 0 -2.857zM4.286 3.571h11.429c0.393 0 0.714 0.321 0.714 0.714v4.286c0 0.393 -0.321 0.714 -0.714 0.714H4.286c-0.393 0 -0.714 -0.321 -0.714 -0.714V4.286c0 -0.393 0.321 -0.714 0.714 -0.714zM2.857 4.286v4.286c0 0.79 0.638 1.429 1.429 1.429h11.429c0.79 0 1.429 -0.638 1.429 -1.429V4.286c0 -0.79 -0.638 -1.429 -1.429 -1.429H4.286c-0.79 0 -1.429 0.638 -1.429 1.429z"/>
            </g>
          </g>
        </g>
      </svg>
    `;
  }

  if (type === 'BOAT') {
    svgContent = `
      <svg width="45px" height="60px" viewBox="0 0 36 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>Icons / Maps / Place experience Active</title>
        <defs>
          <path d="M18 4C10.26 4 4 10.26 4 18c0 10.5 14 26 14 26s14 -15.5 14 -26c0 -7.74 -6.26 -14 -14 -14Z" id="path-1"/>
          <filter x="-30.4%" y="-16.2%" width="160.7%" height="143.7%" filterUnits="objectBoundingBox" id="filter-2">
            <feMorphology radius="0.5" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"/>
            <feOffset dx="0" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.24 0" type="matrix" in="shadowBlurOuter1"/>
          </filter>
          <filter color-interpolation-filters="auto" id="filter-3">
            <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.F5700A 0"/>
          </filter>
        </defs>
        <g id="Icons-/-Maps-/-Place-experience-Active" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Path">
            <use fill="black" fill-opacity="1" filter="url(#filter-2)" xlink:href="#path-1"/>
            <use fill="${mainColor}" fill-rule="evenodd" xlink:href="#path-1"/>
          </g>
          <g id="Filled-/-maps-/-place" transform="translate(8 9)" filter="url(#filter-3)">
            <g>
            <path fill="${fillColor}" d="M8.056 0c-0.767 0 -1.389 0.622 -1.389 1.389v0.833h-1.944c-0.767 0 -1.389 0.622 -1.389 1.389v4.365l-1.354 0.438C1.063 8.712 0.719 9.826 1.309 10.59l2.917 3.75c0.094 0.122 0.267 0.142 0.389 0.049s0.142 -0.267 0.049 -0.389l-2.917 -3.75c-0.354 -0.455 -0.149 -1.125 0.403 -1.306L9.722 6.493v6.563c0 0.153 0.125 0.278 0.278 0.278s0.278 -0.125 0.278 -0.278V6.493l7.573 2.451c0.549 0.177 0.757 0.847 0.403 1.306l-2.917 3.75c-0.094 0.122 -0.073 0.295 0.049 0.389s0.295 0.073 0.389 -0.049l2.917 -3.75c0.59 -0.76 0.247 -1.878 -0.67 -2.174l-1.354 -0.438V3.611c0 -0.767 -0.622 -1.389 -1.389 -1.389h-1.944V1.389c0 -0.767 -0.622 -1.389 -1.389 -1.389H8.056zm4.722 2.222H7.222V1.389c0 -0.462 0.372 -0.833 0.833 -0.833h3.889c0.462 0 0.833 0.372 0.833 0.833v0.833zM6.667 2.778h8.611c0.462 0 0.833 0.372 0.833 0.833v4.184l-5.684 -1.84c-0.278 -0.09 -0.576 -0.09 -0.854 0l-5.684 1.84V3.611c0 -0.462 0.372 -0.833 0.833 -0.833h1.944zm4.521 13.406c-0.351 -0.319 -0.681 -0.677 -0.958 -1.066 -0.104 -0.149 -0.354 -0.149 -0.458 0 -0.278 0.389 -0.608 0.743 -0.958 1.066 -0.597 0.545 -1.365 1.038 -2.146 1.038s-1.549 -0.493 -2.146 -1.038c-0.351 -0.319 -0.684 -0.677 -0.958 -1.066 -0.052 -0.073 -0.135 -0.118 -0.229 -0.118s-0.177 0.045 -0.229 0.118c-0.253 0.358 -0.552 0.681 -0.868 0.983 -0.545 0.514 -1.253 1.014 -1.993 1.108 -0.153 0.021 -0.26 0.16 -0.24 0.309s0.16 0.26 0.309 0.24c0.92 -0.115 1.736 -0.719 2.306 -1.253 0.306 -0.288 0.552 -0.569 0.715 -0.771 0.181 0.222 0.458 0.542 0.813 0.861 0.625 0.566 1.524 1.184 2.521 1.184s1.896 -0.618 2.521 -1.184c0.354 -0.319 0.632 -0.639 0.813 -0.861 0.181 0.222 0.462 0.542 0.813 0.861 0.625 0.566 1.524 1.184 2.521 1.184s1.896 -0.618 2.521 -1.184c0.354 -0.319 0.632 -0.639 0.813 -0.861 0.163 0.201 0.41 0.483 0.715 0.771 0.569 0.535 1.385 1.139 2.306 1.253 0.153 0.021 0.292 -0.09 0.309 -0.24s-0.09 -0.292 -0.24 -0.309c-0.74 -0.094 -1.448 -0.594 -1.993 -1.108 -0.316 -0.299 -0.615 -0.625 -0.868 -0.983 -0.052 -0.073 -0.135 -0.118 -0.229 -0.118s-0.177 0.045 -0.229 0.118c-0.274 0.389 -0.608 0.747 -0.958 1.066 -0.597 0.545 -1.365 1.038 -2.146 1.038s-1.549 -0.493 -2.146 -1.038z"/>
            </g>
          </g>
        </g>
      </svg>
    `;
  }

  if (ExperienceType.isProgram(type)) {
    svgContent = `
      <svg width="45px" height="60px" viewBox="0 0 36 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>Icons / Maps / Place experience Active</title>
        <defs>
          <path d="M18 4C10.26 4 4 10.26 4 18c0 10.5 14 26 14 26s14 -15.5 14 -26c0 -7.74 -6.26 -14 -14 -14Z" id="path-1"/>
          <filter x="-30.4%" y="-16.2%" width="160.7%" height="143.7%" filterUnits="objectBoundingBox" id="filter-2">
            <feMorphology radius="0.5" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"/>
            <feOffset dx="0" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.24 0" type="matrix" in="shadowBlurOuter1"/>
          </filter>
          <filter color-interpolation-filters="auto" id="filter-3">
            <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.F5700A 0"/>
          </filter>
        </defs>
        <g id="Icons-/-Maps-/-Place-experience-Active" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Path">
            <use fill="black" fill-opacity="1" filter="url(#filter-2)" xlink:href="#path-1"/>
            <use fill="${mainColor}" fill-rule="evenodd" xlink:href="#path-1"/>
          </g>
          <g id="Filled-/-maps-/-place" transform="translate(8 9)" filter="url(#filter-3)">
            <g>
            <path fill="${fillColor}" d="M5.357 0c0.196 0 0.357 0.161 0.357 0.357v2.5h8.571V0.357c0 -0.196 0.161 -0.357 0.357 -0.357s0.357 0.161 0.357 0.357v2.5h2.143c1.576 0 2.857 1.281 2.857 2.857v14.286c0 1.576 -1.281 2.857 -2.857 2.857H2.857c-1.576 0 -2.857 -1.281 -2.857 -2.857V5.714c0 -1.576 1.281 -2.857 2.857 -2.857h2.143V0.357c0 -0.196 0.161 -0.357 0.357 -0.357zm13.929 8.571H0.714v11.429c0 1.183 0.96 2.143 2.143 2.143h14.286c1.183 0 2.143 -0.96 2.143 -2.143V8.571zm-14.286 -3.214V3.571H2.857c-1.183 0 -2.143 0.96 -2.143 2.143v2.143h18.571v-2.143c0 -1.183 -0.96 -2.143 -2.143 -2.143h-2.143v1.786c0 0.196 -0.161 0.357 -0.357 0.357s-0.357 -0.161 -0.357 -0.357V3.571H5.714v1.786c0 0.196 -0.161 0.357 -0.357 0.357s-0.357 -0.161 -0.357 -0.357zm6.732 7.451c-0.143 -0.201 -0.442 -0.196 -0.58 0.009l-2.643 3.817c-0.063 0.089 -0.156 0.143 -0.263 0.152s-0.21 -0.027 -0.286 -0.103L6.772 15.491c-0.156 -0.156 -0.415 -0.134 -0.545 0.045l-2.277 3.183c-0.17 0.237 0 0.563 0.29 0.563h11.5c0.29 0 0.46 -0.33 0.29 -0.567l-4.299 -5.906zm-1.17 -0.402c0.42 -0.607 1.313 -0.616 1.746 -0.022L16.607 18.299c0.513 0.71 0.009 1.701 -0.866 1.701H4.246c-0.871 0 -1.379 -0.987 -0.871 -1.692l2.277 -3.183c0.384 -0.54 1.161 -0.603 1.629 -0.134l0.888 0.888 2.393 -3.469zM4.286 12.143a0.714 0.714 0 1 0 1.429 0 0.714 0.714 0 1 0 -1.429 0zm0.714 1.429a1.429 1.429 0 1 1 0 -2.857 1.429 1.429 0 1 1 0 2.857z"/>
            </g>
          </g>
        </g>
      </svg>
    `;
  }

  if (type === 'Activity') {
    svgContent = `
      <svg width="45px" height="60px" viewBox="0 0 36 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>Icons / Maps / Place experience Active</title>
        <defs>
          <path d="M18 4C10.26 4 4 10.26 4 18c0 10.5 14 26 14 26s14 -15.5 14 -26c0 -7.74 -6.26 -14 -14 -14Z" id="path-1"/>
          <filter x="-30.4%" y="-16.2%" width="160.7%" height="143.7%" filterUnits="objectBoundingBox" id="filter-2">
            <feMorphology radius="0.5" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"/>
            <feOffset dx="0" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.24 0" type="matrix" in="shadowBlurOuter1"/>
          </filter>
          <filter color-interpolation-filters="auto" id="filter-3">
            <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.F5700A 0"/>
          </filter>
        </defs>
        <g id="Icons-/-Maps-/-Place-experience-Active" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Path">
            <use fill="black" fill-opacity="1" filter="url(#filter-2)" xlink:href="#path-1"/>
            <use fill="${mainColor}" fill-rule="evenodd" xlink:href="#path-1"/>
          </g>
          <g id="Filled-/-maps-/-place" transform="translate(8 9)" filter="url(#filter-3)">
            <g>
              <path fill="${fillColor}" d="M20.627 14.002a0.944 0.944 0 0 0 -0.496 -0.831 0.314 0.314 0 0 0 -0.296 0.551 0.313 0.313 0 0 1 0.169 0.281 0.311 0.311 0 0 1 -0.169 0.281l-9.087 4.895a0.938 0.938 0 0 1 -0.876 0.007L0.795 14.473a0.313 0.313 0 0 1 -0.173 -0.279 0.313 0.313 0 0 1 0.165 -0.284 0.313 0.313 0 0 0 -0.306 -0.545 0.945 0.945 0 0 0 0.025 1.665l9.075 4.713a1.559 1.559 0 0 0 1.461 -0.011l9.087 -4.895a0.944 0.944 0 0 0 0.496 -0.833z"/>
              <path fill="${fillColor}" d="m0.508 11.024 9.075 4.713a1.559 1.559 0 0 0 1.461 -0.011l9.087 -4.895a0.944 0.944 0 0 0 0.496 -0.833 0.944 0.944 0 0 0 -0.496 -0.831 0.314 0.314 0 0 0 -0.296 0.551 0.313 0.313 0 0 1 0.169 0.281 0.311 0.311 0 0 1 -0.169 0.281l-9.089 4.894a0.935 0.935 0 0 1 -0.876 0.007L0.795 10.468a0.314 0.314 0 0 1 -0.173 -0.279 0.314 0.314 0 0 1 0.165 -0.284 0.313 0.313 0 0 0 -0.306 -0.545 0.944 0.944 0 0 0 -0.484 0.84 0.943 0.943 0 0 0 0.51 0.824z"/>
              <path fill="${fillColor}" d="m0.508 7.019 9.075 4.713c0.221 0.115 0.47 0.175 0.72 0.175h0.001a1.575 1.575 0 0 0 0.741 -0.186l9.087 -4.895a0.944 0.944 0 0 0 0.496 -0.833 0.944 0.944 0 0 0 -0.496 -0.831L11.064 0.276a1.587 1.587 0 0 0 -1.503 0.012L0.481 5.354a0.944 0.944 0 0 0 -0.484 0.84 0.945 0.945 0 0 0 0.51 0.825zM0.787 5.9 9.866 0.834a0.935 0.935 0 0 1 0.901 -0.006l9.067 4.884a0.313 0.313 0 0 1 0.169 0.281 0.311 0.311 0 0 1 -0.169 0.281l-9.087 4.896a0.932 0.932 0 0 1 -0.444 0.112h-0.001a0.929 0.929 0 0 1 -0.431 -0.106L0.795 6.464a0.313 0.313 0 0 1 -0.173 -0.279 0.315 0.315 0 0 1 0.164 -0.284z"/>
            </g>
          </g>
        </g>
      </svg>
    `;
  }

  if (type === 'start') {
    svgContent = `
      <svg width="45px" height="60px" viewBox="0 0 36 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>Icons / Maps / Place experience Active</title>
        <defs>
          <path d="M18 4C10.26 4 4 10.26 4 18c0 10.5 14 26 14 26s14 -15.5 14 -26c0 -7.74 -6.26 -14 -14 -14Z" id="path-1"/>
          <filter x="-30.4%" y="-16.2%" width="160.7%" height="143.7%" filterUnits="objectBoundingBox" id="filter-2">
            <feMorphology radius="0.5" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"/>
            <feOffset dx="0" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.24 0" type="matrix" in="shadowBlurOuter1"/>
          </filter>
          <filter color-interpolation-filters="auto" id="filter-3">
            <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.F5700A 0"/>
          </filter>
        </defs>
        <g id="Icons-/-Maps-/-Place-experience-Active" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Path">
            <use fill="black" fill-opacity="1" filter="url(#filter-2)" xlink:href="#path-1"/>
            <use fill="${mainColor}" fill-rule="evenodd" xlink:href="#path-1"/>
          </g>
          <g id="Filled-/-maps-/-place" transform="translate(8 9)" filter="url(#filter-3)">
            <g>
              <path fill="${fillColor}" d="M10 3.138 3.036 19.719l6.554 -4.589c0.246 -0.174 0.571 -0.174 0.821 0L16.964 19.719 10 3.138zm-1.152 -0.942C9.04 1.732 9.496 1.429 10 1.429s0.96 0.304 1.152 0.768l7.317 17.415c0.067 0.161 0.103 0.335 0.103 0.509v0.054c0 0.696 -0.563 1.259 -1.259 1.259 -0.259 0 -0.509 -0.08 -0.723 -0.228L10 16.585 3.406 21.201c-0.21 0.147 -0.464 0.228 -0.723 0.228 -0.692 0 -1.254 -0.563 -1.254 -1.259v-0.054c0 -0.174 0.036 -0.348 0.103 -0.509l7.317 -17.411z"/>
            </g>
          </g>
        </g>
      </svg>
    `;
  }

  if (type === 'hotel') {
    svgContent = `
      <svg width="45px" height="60px" viewBox="0 0 36 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <title>Icons / Maps / Place Hotel Active</title>
          <defs>
              <path d="M18,4 C10.26,4 4,10.26 4,18 C4,28.5 18,44 18,44 C18,44 32,28.5 32,18 C32,10.26 25.74,4 18,4 Z" id="path-1"></path>
              <filter x="-30.4%" y="-16.2%" width="160.7%" height="143.7%" filterUnits="objectBoundingBox" id="filter-2">
                  <feMorphology radius="0.5" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"></feMorphology>
                  <feOffset dx="0" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
                  <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
                  <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.24 0" type="matrix" in="shadowBlurOuter1"></feColorMatrix>
              </filter>
              <filter color-interpolation-filters="auto" id="filter-3">
                  <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"></feColorMatrix>
              </filter>
          </defs>
          <g id="Icons-/-Maps-/-Place-Hotel-Active" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="Path">
                  <use fill="black" fill-opacity="1" filter="url(#filter-2)" xlink:href="#path-1"></use>
                  <use fill="${mainColor}" fill-rule="evenodd" xlink:href="#path-1"></use>
              </g>
              <g id="Filled-/-maps-/-place" transform="translate(8.000000, 9.000000)" filter="url(#filter-3)">
                  <g>
                    <path d="M6.875,11.9784722 C5.72440677,11.9784722 4.79166667,12.9112123 4.79166667,14.0618056 C4.79166667,15.2123988 5.72440677,16.1451389 6.875,16.1451389 C8.02559323,16.1451389 8.95833333,15.2123988 8.95833333,14.0618056 C8.95833333,12.9112123 8.02559323,11.9784722 6.875,11.9784722 Z M6.875,13.0201389 C7.45029661,13.0201389 7.91666667,13.4865089 7.91666667,14.0618056 C7.91666667,14.6371022 7.45029661,15.1034722 6.875,15.1034722 C6.29970339,15.1034722 5.83333333,14.6371022 5.83333333,14.0618056 C5.83333333,13.4865089 6.29970339,13.0201389 6.875,13.0201389 Z" id="Oval" fill="#000000" fill-rule="nonzero"></path>
                    <path d="M14.3402777,11.9791667 L9.99999994,11.9791667 C9.71235163,11.9791667 9.47916661,12.2123517 9.47916661,12.5 L9.47916661,15.625 C9.47916661,15.9126483 9.71235163,16.1458333 9.99999994,16.1458333 L15.7291666,16.1458333 C16.0168149,16.1458333 16.2499999,15.9126483 16.2499999,15.625 L16.2499999,13.8888889 L16.2444312,13.7469135 C16.158905,12.740575 15.3337437,11.9791667 14.3402777,11.9791667 Z M10.52,15.1041667 L10.52,13.0208333 L14.3402777,13.0208333 C14.7917108,13.0208333 15.1669865,13.3671148 15.2051269,13.8133999 L15.2088039,13.9110256 L15.2075,15.1041667 L10.52,15.1041667 Z" id="Path" fill="#000000" fill-rule="nonzero"></path>
                    <path d="M10,15.1034722 C10.2876483,15.1034722 10.5208333,15.3366572 10.5208333,15.6243056 C10.5208333,15.885804 10.3281184,16.1022915 10.0769649,16.1394917 L10,16.1451389 L4.79166667,16.145 L4.79166667,17.7076389 C4.79166667,17.9691373 4.59895177,18.1856248 4.34779827,18.2228251 L4.27083333,18.2284722 C4.00933487,18.2284722 3.79284739,18.0357573 3.75564717,17.7846038 L3.75,17.7076389 L3.75,15.6243056 C3.75,15.3628071 3.9427149,15.1463196 4.1938684,15.1091194 L4.27083333,15.1034722 L10,15.1034722 Z" id="Path" fill="#000000" fill-rule="nonzero"></path>
                    <path d="M15.7291667,15.1041667 C15.9906651,15.1041667 16.2071526,15.2968816 16.2443528,15.5480351 L16.25,15.625 L16.25,17.7083333 C16.25,17.9959816 16.016815,18.2291667 15.7291667,18.2291667 C15.4676682,18.2291667 15.2511807,18.0364518 15.2139805,17.7852983 L15.2083333,17.7083333 L15.2083333,15.625 C15.2083333,15.3373517 15.4415184,15.1041667 15.7291667,15.1041667 Z" id="Path" fill="#000000" fill-rule="nonzero"></path>
                    <path d="M15.7291667,5.38194444 C15.9906651,5.38194444 16.2071526,5.57465934 16.2443528,5.82581285 L16.25,5.90277778 L16.25,10.4166667 C16.25,10.704315 16.016815,10.9375 15.7291667,10.9375 C15.4676682,10.9375 15.2511807,10.7447851 15.2139805,10.4936316 L15.2083333,10.4166667 L15.2083333,5.90277778 C15.2083333,5.61512947 15.4415184,5.38194444 15.7291667,5.38194444 Z" id="Path" fill="#000000" fill-rule="nonzero"></path>
                    <path d="M4.27083333,5.38194444 C4.53233179,5.38194444 4.74881928,5.57465934 4.7860195,5.82581285 L4.79166667,5.90277778 L4.79166667,10.4166667 C4.79166667,10.704315 4.55848164,10.9375 4.27083333,10.9375 C4.00933487,10.9375 3.79284739,10.7447851 3.75564717,10.4936316 L3.75,10.4166667 L3.75,5.90277778 C3.75,5.61512947 3.98318503,5.38194444 4.27083333,5.38194444 Z" id="Path" fill="#000000" fill-rule="nonzero"></path>
                    <path d="M9.13333314,2.03399007 C9.61778106,1.71105267 10.2376007,1.68621133 10.7429297,1.95950027 L10.8667321,2.03403358 L18.1014543,6.85833914 C18.3407745,7.01792421 18.4054126,7.34130082 18.2458275,7.58062101 C18.102201,7.79600918 17.8259032,7.86990484 17.5976156,7.76619257 L17.5235457,7.7249942 L10.2888903,2.90073321 C10.1389394,2.80077537 9.95008364,2.78649568 9.78906005,2.85786607 L9.71117657,2.90068864 L2.47645434,7.7249942 C2.23713416,7.88457927 1.91375755,7.8199412 1.75417247,7.58062101 C1.6105459,7.36523284 1.64854009,7.08175897 1.8320396,6.91088056 L1.89854566,6.85833914 L9.13333314,2.03399007 Z" id="Path" fill="#000000" fill-rule="nonzero"></path>
                  </g>
              </g>
          </g>
      </svg>
    `;
  }

  if (type === 'poi') {
    svgContent = `<svg width="45px" height="60px" viewBox="0 0 36 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <title>Icons / Maps / Place Hotel Active</title>
      <defs>
          <path d="M18,4 C10.26,4 4,10.26 4,18 C4,28.5 18,44 18,44 C18,44 32,28.5 32,18 C32,10.26 25.74,4 18,4 Z" id="path-1"></path>
          <filter x="-30.4%" y="-16.2%" width="160.7%" height="143.7%" filterUnits="objectBoundingBox" id="filter-2">
              <feMorphology radius="0.5" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"></feMorphology>
              <feOffset dx="0" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
              <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
              <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.24 0" type="matrix" in="shadowBlurOuter1"></feColorMatrix>
          </filter>
          <filter color-interpolation-filters="auto" id="filter-3">
              <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"></feColorMatrix>
          </filter>
      </defs>
      <g id="Icons-/-Maps-/-Place-Hotel-Active" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Path">
              <use fill="black" fill-opacity="1" filter="url(#filter-2)" xlink:href="#path-1"></use>
              <use fill="${mainColor}" fill-rule="evenodd" xlink:href="#path-1"></use>
          </g>
          <g transform="matrix(0 0 0 0 0 0)" id="4bfdbf72-fb7f-4847-bffe-c3e48bf811a0"  >
          </g>
          <g transform="matrix(1 0 0 1 18 24)" id="54b94ae6-e59b-47a2-9a4c-cf0c694dce85"  >
          <rect style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-rule: nonzero; opacity: 1; visibility: hidden;" vector-effect="non-scaling-stroke"  x="-18" y="-24" rx="0" ry="0" width="36" height="48" />
          </g>
          <g transform="matrix(0.03 0 0 0.03 18.38 11.5)"  >
          <path fill="${fillColor}" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill-rule: nonzero; opacity: 1;"  transform=" translate(-320, -256)" d="M 45.6 64 C 38.1 64 32 70.1 32 77.6 L 32 434.4 C 32 441.9 38.1 448 45.6 448 C 47.2 448 48.6 447.8 50.1 447.3 C 52.6 446.5 57.2 445 63.7 443 L 67.10000000000001 438.4 L 198.4 263.5 C 211.20000000000002 246.4 236.8 246.4 249.60000000000002 263.5 L 280 304 L 358.4 199.5 C 371.2 182.4 396.79999999999995 182.4 409.59999999999997 199.5 L 588.8 438.4 L 595.9 447.9 C 602.6999999999999 447.09999999999997 608 441.4 608 434.4 L 608 77.6 C 608 70.1 601.9 63.99999999999999 594.4 63.99999999999999 C 592.8 63.99999999999999 591.4 64.19999999999999 589.9 64.69999999999999 C 573.6 70.2 467.1 104 320 104 C 172.89999999999998 104 66.4 70.2 50.2 64.7 C 48.7 64.2 47.2 64 45.7 64 z M 546.1 434.9 L 384 218.7 L 292.8 340.3 L 239.5 411.4 C 264.6 409.29999999999995 291.5 408 320 408 C 418.6 408 499 423.2 546.1 434.9 z M 196 415.9 L 260 330.59999999999997 L 224 282.59999999999997 L 113.3 430.3 C 136 425.3 163.9 420.1 196.1 415.90000000000003 z M 60.4 477.6 C 55.699999999999996 479.20000000000005 50.7 480 45.7 480 C 20.4 480 0 459.6 0 434.4 L 0 77.6 C 0 52.4 20.4 32 45.6 32 C 50.7 32 55.6 32.8 60.3 34.4 C 74.6 39.2 177.6 72 320 72 C 462.4 72 565.4 39.2 579.6 34.4 C 584.3000000000001 32.8 589.3000000000001 32 594.3000000000001 32 C 619.6 32 640 52.4 640 77.6 L 640 434.4 C 640 459.59999999999997 619.6 480 594.4 480 C 589.4 480 584.4 479.2 579.6999999999999 477.6 C 565.4 472.8 462.4 440 320 440 C 177.60000000000002 440 74.6 472.8 60.39999999999998 477.6 z M 112 184 C 112 170.74516600406096 122.74516600406096 160 136 160 C 149.25483399593904 160 160 170.74516600406096 160 184 C 160 197.25483399593904 149.25483399593904 208 136 208 C 122.74516600406096 208 112 197.25483399593904 112 184 z" stroke-linecap="round" />
          </g>
          <g transform="matrix(NaN NaN NaN NaN 0 0)"  >
          <g style=""   >
          </g>
          </g>
          <g transform="matrix(NaN NaN NaN NaN 0 0)"  >
          <g style=""   >
          </g>
          </g>
          <g transform="matrix(NaN NaN NaN NaN 0 0)"  >
          <g style=""   >
          </g>
          </g>
      </g>
    </svg>`;
  }

  if (type === 'programDay') {
    svgContent = `<svg width="45px" height="60px" viewBox="0 0 36 48" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <title>Icons / Maps / Place Hotel Active</title>
      <defs>
          <path d="M18,4 C10.26,4 4,10.26 4,18 C4,28.5 18,44 18,44 C18,44 32,28.5 32,18 C32,10.26 25.74,4 18,4 Z" id="path-1"></path>
          <filter x="-30.4%" y="-16.2%" width="160.7%" height="143.7%" filterUnits="objectBoundingBox" id="filter-2">
              <feMorphology radius="0.5" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"></feMorphology>
              <feOffset dx="0" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
              <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
              <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.24 0" type="matrix" in="shadowBlurOuter1"></feColorMatrix>
          </filter>
          <filter color-interpolation-filters="auto" id="filter-3">
              <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"></feColorMatrix>
          </filter>
      </defs>
      <g id="Icons-/-Maps-/-Place-Hotel-Active" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Path">
              <use fill="black" fill-opacity="1" filter="url(#filter-2)" xlink:href="#path-1"></use>
              <use fill="${mainColor}" fill-rule="evenodd" xlink:href="#path-1"></use>
          </g>
          <g transform="matrix(1 0 0 1 18 24)" id="54b94ae6-e59b-47a2-9a4c-cf0c694dce85"  >
          <rect style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill: rgb(255,255,255); fill-rule: nonzero; opacity: 1; visibility: hidden;" vector-effect="non-scaling-stroke"  x="-18" y="-24" rx="0" ry="0" width="36" height="48" />
          </g>
          <g transform="matrix(0 0 0 0 0 0)" id="4bfdbf72-fb7f-4847-bffe-c3e48bf811a0"  >
          </g>
          <g transform="matrix(0 0 0 0 0 0)"  >
          <g style=""   >
          </g>
          </g>
          <g transform="matrix(0.03 0 0 0.03 18 13)"  >
          <path fill="${fillColor}" style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: miter; stroke-miterlimit: 4; fill-rule: nonzero; opacity: 1;"  transform=" translate(-224, -256)" d="M 112 0 C 120.8 0 128 7.2 128 16 L 128 64 L 320 64 L 320 16 C 320 7.199999999999999 327.2 0 336 0 C 344.8 0 352 7.2 352 16 L 352 64 L 384 64 C 419.3 64 448 92.7 448 128 L 448 160 L 448 192 L 448 448 C 448 483.3 419.3 512 384 512 L 64 512 C 28.700000000000003 512 0 483.3 0 448 L 0 192 L 0 160 L 0 128 C 0 92.7 28.7 64 64 64 L 96 64 L 96 16 C 96 7.199999999999999 103.2 0 112 0 z M 416 192 L 32 192 L 32 448 C 32 465.7 46.3 480 64 480 L 384 480 C 401.7 480 416 465.7 416 448 L 416 192 z M 384 96 L 64 96 C 46.3 96 32 110.3 32 128 L 32 160 L 416 160 L 416 128 C 416 110.3 401.7 96 384 96 z M 230 265.4 C 242.5 247.29999999999998 269.2 246.99999999999997 282.2 264.79999999999995 L 378.5 397.19999999999993 C 393.9 418.3999999999999 378.8 447.99999999999994 352.6 447.99999999999994 L 95.1 447.99999999999994 C 69.1 447.99999999999994 53.89999999999999 418.59999999999997 69.1 397.3999999999999 L 120.1 326.0999999999999 C 131.6 309.9999999999999 154.8 308.0999999999999 168.8 322.0999999999999 L 181.9 335.19999999999993 L 230 265.4 z M 352.6 416 L 256.3 283.6 L 197.10000000000002 369.1 C 194.40000000000003 373 190.10000000000002 375.5 185.40000000000003 375.90000000000003 C 180.70000000000005 376.30000000000007 176.00000000000003 374.6 172.60000000000002 371.3 L 146 344.7 L 95.1 416 L 352.6 416 z M 96 232 C 109.25483399593904 232 120 242.74516600406096 120 256 C 120 269.25483399593907 109.25483399593905 280 96.00000000000001 280 C 82.74516600406096 280 72 269.25483399593907 72 256 C 72 242.74516600406096 82.74516600406096 232 96 232 z" stroke-linecap="round" />
          </g>
          <g transform="matrix(0 0 0 0 0 0)"  >
          <g style=""   >
          </g>
          </g>
          <g transform="matrix(0 0 0 0 0 0)"  >
          <g style=""   >
          </g>
          </g>
          <g transform="matrix(0 0 0 0 0 0)"  >
          <g style=""   >
          </g>
          </g>
          <g transform="matrix(0 0 0 0 0 0)"  >
          <g style=""   >
          </g>
          </g>
          <g transform="matrix(0 0 0 0 0 0)"  >
          <g style=""   >
          </g>
          </g>
          <g transform="matrix(0 0 0 0 0 0)"  >
          <g style=""   >
          </g>
          </g>
          <g transform="matrix(0 0 0 0 0 0)"  >
          <g style=""   >
          </g>
          </g>
          <g transform="matrix(0 0 0 0 0 0)"  >
          <g style=""   >
          </g>
          </g>
          <g transform="matrix(NaN NaN NaN NaN 0 0)"  >
          <g style=""   >
          </g>
          </g>
          <g transform="matrix(NaN NaN NaN NaN 0 0)"  >
          <g style=""   >
          </g>
          </g>
          <g transform="matrix(NaN NaN NaN NaN 0 0)"  >
          <g style=""   >
          </g>
          </g>
          <g transform="matrix(NaN NaN NaN NaN 0 0)"  >
          <g style=""   >
          </g>
          </g>
          <g transform="matrix(NaN NaN NaN NaN 0 0)"  >
          <g style=""   >
          </g>
          </g>
          <g transform="matrix(NaN NaN NaN NaN 0 0)"  >
          <g style=""   >
          </g>
          </g>
          <g transform="matrix(NaN NaN NaN NaN 0 0)"  >
          <g style=""   >
          </g>
          </g>
          <g transform="matrix(NaN NaN NaN NaN 0 0)"  >
          <g style=""   >
          </g>
          </g>
          <g transform="matrix(NaN NaN NaN NaN 0 0)"  >
          <g style=""   >
          </g>
          </g>
      </g>
    </svg>`;
  }

  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgContent)}`;
};
